import { createContext } from 'react';
import type { useManageInvestorsController } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/useManageInvestorsController';

export const MIPManageInvestorsV2Context = createContext<
	ReturnType<typeof useManageInvestorsController>
>({} as ReturnType<typeof useManageInvestorsController>);
